<div class="jammcard-modal flex column">
  <div class="jammcard-modal__image" [ngStyle]="backgroundStyles"></div>
  <ng-content></ng-content>
</div>
